import { WEBCODE_SKIP } from "./const";

function action() {
  return {
    type: WEBCODE_SKIP,
  };
}

export default action;
